import React, { useState, useCallback } from 'react';
import { Range } from 'react-range';

export const RangeSlider = ({
	initialMin,
	initialMax,
	minLimit,
	maxLimit,
	onValuesChange,
	resetFilters
}) => {
	const safeMax = maxLimit > minLimit ? maxLimit : minLimit + 1;

	// Ensure initial values are integers
	const [values, setValues] = useState([
		initialMin,
		Math.min(initialMax, safeMax),
	]);

	const isFloat = (num) => num % 1 !== 0;
	const shouldUseFloatStep = isFloat(minLimit) || isFloat(safeMax);
	const stepValue = shouldUseFloatStep ? 0.5 : 1;

	const roundValues = (values, shouldUseFloatStep) =>
		values.map(value => shouldUseFloatStep ? Math.round(value * 2) / 2 : Math.round(value));

	const handleFinalChange = useCallback((newValues) => {
		const shouldUseFloatStep = isFloat(minLimit) || isFloat(safeMax);
		const roundedValues = roundValues(newValues, shouldUseFloatStep);

		setValues(roundedValues);
		onValuesChange?.(roundedValues); // Call function only if defined
	}, [onValuesChange, minLimit, maxLimit]);

	const handleChange = useCallback((newValues) => {
		const shouldUseFloatStep = isFloat(minLimit) || isFloat(safeMax);
		setValues(roundValues(newValues, shouldUseFloatStep));
	}, [minLimit, safeMax]);
	;

	return (
		<div className="range-slider-container" style={{ margin: '20px', width: '300px' }}>
			<Range
				step={stepValue}
				min={minLimit}
				max={safeMax}
				values={values}
				onFinalChange={handleFinalChange}
				onChange={handleChange}
				renderTrack={({ props, children }) => (
					<div
						{...props}
						style={{
							...props.style,
							height: '6px',
							width: '100%',
							backgroundColor: '#ccc',
							borderRadius: '3px'
						}}
					>
						{children}
					</div>
				)}
				renderThumb={({ props, index }) => (
					<div
						{...props}
						style={{
							...props.style,
							height: '16px',
							width: '16px',
							backgroundColor: '#000',
							borderRadius: '50%',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}}
					>
						<span style={{
							fontSize: '10px',
							color: '#fff',
							position: 'absolute',
							top: '-20px'
						}}>
							{values[index]}
						</span>
					</div>
				)}
			/>
			<div
				className="value-labels"
				style={{
					marginTop: '10px',
					display: 'flex',
					justifyContent: 'space-between'
				}}
			>
				<span>Min: {values[0]}</span>
				<span>Max: {values[1]}</span>
			</div>
			<button
				onClick={() => { handleChange([initialMin, initialMax]); resetFilters(); }}
				style={{ marginTop: '10px', padding: '5px 15px' }}
			>
				Reset filter
			</button>
		</div>
	);
};